'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];
    var state = arguments[2];

    theme = Object.assign({}, baseTheme(theme), theme);

    var appearance = void 0;

    var lineHeight = typeof theme.lineHeight === 'number' ? (0, _pixelToNumber2.default)(theme.fontSize) * theme.lineHeight : (0, _pixelToNumber2.default)(theme.lineHeight),
        bottom = (lineHeight + (0, _pixelToNumber2.default)(theme.paddingBottom) + (0, _pixelToNumber2.default)(theme.paddingTop)) / 2;

    if (state.visa) {
        appearance = theme.appearanceVisa;
    } else if (state.mc) {
        appearance = theme.appearanceMC;
    } else {
        appearance = theme.appearanceCard;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            width: theme.width,
            minWidth: theme.minWidth,
            position: 'relative'
        },
        issuer: {
            position: 'absolute',
            left: 0,
            bottom: bottom + 'px',
            transform: 'translateY(50%)',
            width: theme.appearanceWidth,
            height: theme.appearanceHeight,
            backgroundImage: appearance,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        issuer: (0, _aphroditeJss.css)(styleList.issuer)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _visa = require('../img/visa.svg');

var _visa2 = _interopRequireDefault(_visa);

var _mc = require('../img/mc.svg');

var _mc2 = _interopRequireDefault(_mc);

var _card = require('../img/card.svg');

var _card2 = _interopRequireDefault(_card);

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        appearanceVisa: 'url("' + _visa2.default + '")',
        appearanceMC: 'url("' + _mc2.default + '")',
        appearanceCard: 'url("' + _card2.default + '")',
        lineHeight: 1.5,
        fontSize: theme.tsNormal,
        paddingTop: theme.gutter + 'px',
        paddingBottom: theme.gutter + 'px',
        width: 'auto',
        minWidth: 'auto',
        appearanceWidth: '30px',
        appearanceHeight: '20px'
    };
};